import React from 'react';
import Icon from '../../../components/AppIcon';

const ProductTypeModal = ({ isOpen, onClose, onSelectType }) => {
  if (!isOpen) return null;

  const productTypes = [
    {
      type: 'book',
      title: 'Libro',
      description: 'Crear un nuevo libro con autor, categorías y detalles completos',
      icon: 'Book',
      color: 'bg-[#0b3452] hover:bg-[#0b3452]/90'
    },
    {
      type: 'bible',
      title: 'Biblia',
      description: 'Crear una nueva biblia con versión, formato y características específicas',
      icon: 'BookOpen',
      color: 'bg-[#0b3452] hover:bg-[#0b3452]/90'
    },
    {
      type: 'thing',
      title: 'Otro',
      description: 'Crear otro tipo de producto con información básica',
      icon: 'Package',
      color: 'bg-[#0b3452] hover:bg-[#0b3452]/90'
    }
  ];

  const handleSelectType = (type) => {
    onSelectType(type);
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto p-4 sm:p-6">
        {/* Header */}
        <div className="flex items-center justify-between mb-4 sm:mb-6">
          <h2 className="text-lg sm:text-2xl font-bold text-slate-800 pr-2">
            Seleccionar Tipo de Producto
          </h2>
          <button
            onClick={onClose}
            className="text-slate-400 hover:text-slate-600 transition-colors flex-shrink-0 p-1"
          >
            <Icon name="X" size={20} className="sm:w-6 sm:h-6" />
          </button>
        </div>

        {/* Description */}
        <p className="text-slate-600 mb-4 sm:mb-8 text-left text-sm sm:text-base">
          ¿Qué tipo de producto deseas crear?
        </p>

        {/* Product Type Options */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
          {productTypes.map((product) => (
            <button
              key={product.type}
              onClick={() => handleSelectType(product.type)}
              className={`${product.color} text-white p-4 sm:p-6 rounded-lg transition-all duration-200 transform hover:scale-105 focus:outline-none focus:ring-4 focus:ring-opacity-50 focus:ring-blue-300 min-h-[140px] sm:min-h-[180px]`}
            >
              <div className="flex flex-col items-center text-center space-y-2 sm:space-y-3 h-full justify-center">
                <div className="bg-white bg-opacity-20 p-2 sm:p-3 rounded-full">
                  <Icon name={product.icon} size={24} className="sm:w-8 sm:h-8" />
                </div>
                <h3 className="text-base sm:text-lg font-semibold">
                  {product.title}
                </h3>
                <p className="text-xs sm:text-sm opacity-90 leading-relaxed px-1">
                  {product.description}
                </p>
              </div>
            </button>
          ))}
        </div>

        {/* Cancel Button */}
        <div className="flex justify-center mt-6 sm:mt-8">
          <button
            onClick={onClose}
            className="bg-slate-200 text-slate-700 px-4 sm:px-6 py-2 sm:py-2.5 rounded-lg font-medium shadow-md hover:bg-slate-300 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-slate-400 text-sm sm:text-base w-full sm:w-auto"
          >
            Cancelar
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductTypeModal;

